import { Pipe, PipeTransform } from '@angular/core';
import max from 'date-fns/max';
import format from 'date-fns/format';
import { parsedOutput } from '../helper-functions';
import { DatePipeManager } from '../providers/date-pipe-manager';
export class MaxDatePipe implements PipeTransform {
/**
 * Returns the max date from an array of dates
 * @param {?} manager
 */
constructor(private manager: DatePipeManager) {}
/**
 * @param {?} range
 * @param {?=} dateFormat
 * @return {?}
 */
transform(range: Array<string | number | Date>, dateFormat?: string) {
    const /** @type {?} */ formatToUse = this.manager.getDefaultFormat(dateFormat);
    return format(max(...range), formatToUse);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'maxDate',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatePipeManager, },
];
}

function MaxDatePipe_tsickle_Closure_declarations() {
/** @type {?} */
MaxDatePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MaxDatePipe.ctorParameters;
/** @type {?} */
MaxDatePipe.prototype.manager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
